import React, { useContext } from 'react';

import AppContext, { IAppContext } from '~/contexts/AppContext';

import useNavigationStyles from './NavigationJSS';
import MobileMenu from './MobileMenu/MobileMenu';
import Menu from './Menu/Menu';

import type { NavigationPropsModel } from './types';

const Navigation = ({ isMobileView = false, path }: NavigationPropsModel) => {
  const classes = useNavigationStyles();
  const { navigationItems } = useContext<IAppContext>(AppContext);
  return (
    <nav>
      <ul className={classes.navList}>
        {isMobileView ? (
          <MobileMenu menu={navigationItems} path={path} />
        ) : (
          <Menu menu={navigationItems} path={path} />
        )}
      </ul>
    </nav>
  );
};

export default Navigation;
